export default "__VITE_ASSET__CV5JUi1k__"